import type { CallIntroFlowQuestions } from "@expert/contentful/src/api/getCallIntroFlowQuestions";
import type { Partner } from "@expert/shared-types";

import { type JSX, useState } from "react";

import type { ChannelShareData } from "./customer-info/types";

import { CallIntroQuestionsView } from "./CallIntroQuestionsView";
import { useIsPartnerUsingSingleIntroQuestionResponse } from "./hooks/useIsPartnerUsingSingleIntroQuestionResponse";
import { shouldShowCallIntroFlowQuestions } from "./utils/shouldShowCallIntroFlowQuestions";

export interface CallIntroQuestionsProps {
    onSubscriptionsChange: (subscriptions: string[] | undefined) => void;
    partner: Partner | undefined;
    callDetails: ChannelShareData;
    questions: CallIntroFlowQuestions | undefined;
}

export function CallIntroQuestions({
    onSubscriptionsChange,
    partner,
    callDetails,
    questions,
}: CallIntroQuestionsProps): JSX.Element | null {
    const isSingleSelection = useIsPartnerUsingSingleIntroQuestionResponse(partner ?? "asurion");

    const [currentSubscriptions, setCurrentSubscriptions] = useState<string[] | undefined>();

    if (!questions?.options.length || !questions?.question) {
        return null;
    }

    if (!partner || !shouldShowCallIntroFlowQuestions(partner, callDetails)) {
        return null;
    }

    const handleSubscriptionsChange = (subscriptions: string[] | undefined) => {
        setCurrentSubscriptions(subscriptions);
        onSubscriptionsChange(subscriptions);
    };

    return (
        <CallIntroQuestionsView
            questions={questions}
            isSingleSelection={isSingleSelection}
            currentSubscriptions={currentSubscriptions}
            onSubscriptionsChange={handleSubscriptionsChange}
        />
    );
}
